import { makeCygnusApiCall } from "../../../../../api/api";
import {
  ClientTypeCode,
  SelectedFieldsRecord,
  SystemField,
} from "./SystemFieldDrawer.types";

export const getAllSystemFields = async (): Promise<SystemField[]> => {
  const response = await makeCygnusApiCall({
    type: "GET",
    url: "/onboarding/all_available_fields/",
    show_message: false,
    customized_failure_message: "Failed to fetch available fields.",
    customized_error_message: "Error occurred while fetching available fields.",
    forMDM: true,
  });

  return response?.success ? response.data || [] : [];
};

export const getSelectedSystemFields = async (): Promise<SelectedFieldsRecord[]> => {
  const response = await makeCygnusApiCall({
    type: "GET",
    url: "/onboarding/firm_selected_fields/",
    show_message: false,
    customized_failure_message: "Failed to fetch selected fields.",
    customized_error_message: "Error occurred while fetching selected fields.",
    forMDM: true,
  });

  return response?.success ? response.data || [] : [];
};

export const getFieldCategoryOptions = async (): Promise<any[]> => {
  const response = await makeCygnusApiCall({
    type: "GET",
    url: "/reference_data?ReferenceDataDomain=ClientFieldCategory",
    show_message: false,
    customized_failure_message: "Failed to fetch field categories.",
    customized_error_message: "Error occurred while fetching field categories.",
    forMDM: true,
  });

  return response?.success ? response.data || [] : [];
};

export const saveSystemFieldSelection = async (
  clientType: ClientTypeCode,
  fieldCodes: string[],
  showMessage = false
): Promise<boolean> => {
  const response = await makeCygnusApiCall({
    type: "POST",
    url: "/onboarding/firm_selected_fields/",
    payload: {
      codes: fieldCodes,
      Update: true,
      ClientType: clientType,
    },
    show_message: showMessage,
    customized_success_message: "Field selected successfully.",
    customized_failure_message: "Failed to select the field.",
    customized_error_message: "Error occurred while selecting the field.",
    forMDM: true,
  });

  return !!response?.success;
};

export const createCustomSystemField = async (payload: {
  field_name: string;
  field_type: string;
  field_category: string;
  field_purpose: string[];
  field_options?: { id: number; label: string; value: string }[];
}): Promise<boolean> => {
  const response = await makeCygnusApiCall({
    type: "POST",
    url: "/onboarding/create_custom_field/",
    payload,
    show_message: true,
    customized_success_message: "Custom field added successfully.",
    customized_failure_message: "Failed to add custom field.",
    customized_error_message: "An error occurred while adding the custom field.",
    forMDM: true,
  });

  return !!response?.success;
};
